import { ModalScreens } from 'components/Navigation/types';
import { produce } from 'immer';
import { isError, isNetworkError } from 'lib/isError';
import { noop } from 'lodash';
import { apiGet, apiPost } from 'service/api';
import * as http from 'service/api/constants';
import {
  ALERT_ERROR,
  HIDE_BLOCKING_LOADER,
  NAVIGATE_MODAL,
  SHOW_BLOCKING_LOADER,
} from 'store/app/actions';
import { selectAssetIds } from 'store/assets/selectors';
import {
  CACHE_LAST_GOOD_REQUEST,
  OPEN_CLOUD_ASSETS,
  REFETCH_SEARCH,
  SEARCH,
  SET_CLOUD_ASSET_OPTIONS,
  SET_FILTER,
  SET_LIMIT,
  SET_OFFSET,
  SET_SORT,
} from 'store/search/actions';
import {
  selectSearchBlockedByOrganisationFilter,
  selectSearchRequest,
} from 'store/search/selectors';
import { SearchOptions, SearchResults } from 'store/search/types';
import { put, select, takeEvery } from 'typed-redux-saga';

export const searchSideEffects = [
  takeEvery(OPEN_CLOUD_ASSETS, function* f(action) {
    yield* put(SHOW_BLOCKING_LOADER());
    try {
      const response = yield* apiGet<SearchOptions>(http.SEARCH_PREFLIGHT);
      yield* put(HIDE_BLOCKING_LOADER());
      yield* put(SET_CLOUD_ASSET_OPTIONS(response));
      yield* put(
        NAVIGATE_MODAL({
          screen: ModalScreens.CLOUDASSETS,
          params: { show: true },
        }),
      );
      yield* put(REFETCH_SEARCH());
    } catch (error) {
      yield* put(HIDE_BLOCKING_LOADER());
      if (isError(error)) {
        yield* put(ALERT_ERROR({ action, error }));
      }
    }
  }),
  takeEvery(
    [SET_FILTER, SET_SORT, SET_LIMIT, SET_OFFSET, REFETCH_SEARCH],
    function* f() {
      try {
        if (yield* select(selectSearchBlockedByOrganisationFilter)) {
          return;
        }
        const parameters = yield* select(selectSearchRequest);
        const excludeAssets = yield* select(selectAssetIds);
        const request = produce(parameters, (draft) => {
          draft.filter.exclude_assets = excludeAssets;
        });
        yield* put(SEARCH.request(request));
      } catch (_) {
        noop();
      }
    },
  ),
  takeEvery(SEARCH.request, function* f(action) {
    try {
      yield* put(SHOW_BLOCKING_LOADER());
      const response = yield* apiPost<SearchResults>(
        http.SEARCH,
        action.payload,
        {
          abortKey: 'cloudAssetsSearch',
        },
      );
      yield* put(HIDE_BLOCKING_LOADER());
      yield* put(SEARCH.success(response));
      yield* put(CACHE_LAST_GOOD_REQUEST(action.payload));
    } catch (error) {
      yield* put(HIDE_BLOCKING_LOADER());
      if (!isNetworkError(error) || !error.isCancelled) {
        yield* put(SEARCH.failure());
        if (isError(error)) {
          yield* put(ALERT_ERROR({ action, error }));
        }
      }
    }
  }),
];
